import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _01610051 = () => interopDefault(import('../pages/client/index.vue' /* webpackChunkName: "" */))
const _4b511b3d = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "" */))
const _602e522a = () => interopDefault(import('../pages/orders/index.vue' /* webpackChunkName: "" */))
const _7d06cd62 = () => interopDefault(import('../pages/orderDetail/index.vue' /* webpackChunkName: "" */))
const _dc0718aa = () => interopDefault(import('../pages/reviews/index.vue' /* webpackChunkName: "" */))
const _9fe52e66 = () => interopDefault(import('../pages/clubs/index.vue' /* webpackChunkName: "" */))
const _480ddd53 = () => interopDefault(import('../pages/watchdog/index.vue' /* webpackChunkName: "" */))
const _e90419ea = () => interopDefault(import('../pages/wishlist/index.vue' /* webpackChunkName: "" */))
const _7c937de8 = () => interopDefault(import('../pages/wishlist/detail.vue' /* webpackChunkName: "" */))
const _2bdc4c00 = () => interopDefault(import('../pages/wishlist/public.vue' /* webpackChunkName: "" */))
const _19885861 = () => interopDefault(import('../pages/finishAccountDeactivation/index.vue' /* webpackChunkName: "" */))
const _4b76ab0c = () => interopDefault(import('../pages/delivery/index.vue' /* webpackChunkName: "" */))
const _0163526b = () => interopDefault(import('../pages/deliveryDetail/index.vue' /* webpackChunkName: "" */))
const _e3a06d3a = () => interopDefault(import('../pages/processChangeEmail/index.vue' /* webpackChunkName: "" */))
const _1e2cdafe = () => interopDefault(import('../pages/subscriptionOptout/index.vue' /* webpackChunkName: "" */))
const _7910e48c = () => interopDefault(import('../pages/rmaAuthorizedService/index.vue' /* webpackChunkName: "" */))
const _ec6af7f8 = () => interopDefault(import('../pages/passwordReset/index.vue' /* webpackChunkName: "" */))
const _117c5102 = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "" */))
const _4c70ca7b = () => interopDefault(import('../pages/registration/sent.vue' /* webpackChunkName: "" */))
const _0bb3ab36 = () => interopDefault(import('../pages/registration/finish.vue' /* webpackChunkName: "" */))
const _f07e36da = () => interopDefault(import('../pages/header/index.vue' /* webpackChunkName: "" */))
const _8e8f85d6 = () => interopDefault(import('../pages/personalDataForms/index.vue' /* webpackChunkName: "" */))
const _4a6c5a25 = () => interopDefault(import('../pages/personalDataForms/sent.vue' /* webpackChunkName: "" */))
const _1256dd74 = () => interopDefault(import('../pages/personalDataForms/verify.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/klient",
    component: _01610051,
    alias: ["/ugyfel","/uporabnik"],
    name: "clientCustomerCenter"
  }, {
    path: "/klient/muj-ucet",
    component: _4b511b3d,
    alias: ["/klient/my-account","/ugyfel/my-account","/uporabnik/moj-racun"],
    name: "clientMyAccount"
  }, {
    path: "/klient/objednavky",
    component: _602e522a,
    alias: ["/klient/orders","/ugyfel/orders","/uporabnik/narocila"],
    name: "clientOrders"
  }, {
    path: "/klient/kc-purchase-detail/:orderId",
    component: _7d06cd62,
    alias: ["/ugyfel/kc-purchase-detail/:orderId","/uporabnik/kc-purchase-detail/:orderId"],
    name: "clientOrderDetail"
  }, {
    path: "/hodnoceni/",
    component: _dc0718aa,
    alias: ["/hodnotenie/","/recenzje/","/ertekelesek/","/misljenja/","/mnenja/"],
    name: "reviews"
  }, {
    path: "/klient/vernostni-kluby",
    component: _9fe52e66,
    alias: ["/klient/vernostne-kluby","/klient/","/ugyfel/","/uporabnik/"],
    name: "clientLoyalityClubs"
  }, {
    path: "/klient/watchdog",
    component: _480ddd53,
    alias: ["/ugyfel/watchdog","/uporabnik/watchdog","/uporabnik/sledilec"],
    name: "clientWatchdog"
  }, {
    path: "/klient/wishlist",
    component: _e90419ea,
    alias: ["/ugyfel/wishlist","/uporabnik/wishlist","/uporabnik/seznami"],
    name: "clientWishlist"
  }, {
    path: "/klient/wishlist-detail/:wishlistId",
    component: _7c937de8,
    alias: ["/ugyfel/wishlist-detail/:wishlistId","/uporabnik/wishlist-detail/:wishlistId"],
    name: "clientWishlistDetail"
  }, {
    path: "/wishlists/:wishlistHash",
    component: _2bdc4c00,
    name: "publicWishlist"
  }, {
    path: "/klient/zruseni-uctu",
    component: _19885861,
    alias: ["/klient/user-deactivation","/ugyfel/user-deactivation","/uporabnik/ukinitev-racuna"],
    name: "clientFinishAccountDeactivation"
  }, {
    path: "/sledovani-objednavky",
    component: _4b76ab0c,
    alias: ["/sledovanie-objednavky","/sledzenie-zamowienia","/rendeleskovetes","/pracenje-narudzbe","/sledenje-narocila"],
    name: "orderTrackingSearch"
  }, {
    path: "/sledovani-objednavky/:orderId",
    component: _4b76ab0c,
    alias: ["/sledovanie-objednavky/:orderId","/sledzenie-zamowienia/:orderId","/rendeleskovetes/:orderId","/pracenje-narudzbe/:orderId","/sledenje-narocila/:orderId"],
    name: "orderTracking"
  }, {
    path: "/sledovani-objednavky/detail/:orderId/:deliveryId",
    component: _0163526b,
    alias: ["/sledovanie-objednavky/detail/:orderId/:deliveryId","/sledzenie-zamowienia/detail/:orderId/:deliveryId","/rendeleskovetes/detail/:orderId/:deliveryId","/pracenje-narudzbe/detail/:orderId/:deliveryId","/sledenje-narocila/detail/:orderId/:deliveryId"],
    name: "orderTrackingDetail"
  }, {
    path: "/zmena-emailu/processChangeEmail",
    component: _e3a06d3a,
    alias: ["/zmien-email/processChangeEmail","/email-modositasa/processChangeEmail","/promijenite-email/processChangeEmail","/spremenite-email/processChangeEmail"],
    name: "userChangeEmail"
  }, {
    path: "/odhlaseni-odberu/",
    component: _1e2cdafe,
    alias: ["/odhlasenie-odberu/","/rezygnacja-z-subskrypcji/","/leiratkozas/","/iskljucivanje-pretplate/","/odjava-narocnine/"],
    name: "subscriptionOptout"
  }, {
    path: "/servisy",
    component: _7910e48c,
    name: "rmaAuthorizedServices"
  }, {
    path: "/user/password-recovery/recovery",
    component: _ec6af7f8,
    name: "userForgottenPassword"
  }, {
    path: "/user/register/register",
    component: _117c5102,
    name: "userRegistration"
  }, {
    path: "/user/register/sent",
    component: _4c70ca7b,
    name: "userRegistrationSent"
  }, {
    path: "/user/register/finish",
    component: _0bb3ab36,
    name: "userRegistrationFinish"
  }, {
    path: "/header/:shopId",
    component: _f07e36da,
    name: "header"
  }, {
    path: "/sprava-osobnich-udaju",
    component: _8e8f85d6,
    alias: ["/sprava-osobnych-udajov","/zarzadzanie-danymi-osobowymi","/szemelyes-adatok-kezelese","/uredivanje-osobnih-podataka","/urejanje-osebnih-podatkov"],
    name: "personalDataForms"
  }, {
    path: "/sprava-osobnich-udaju/odeslano",
    component: _4a6c5a25,
    alias: ["/sprava-osobnych-udajov/odoslane","/zarzadzanie-danymi-osobowymi/wyslane","/szemelyes-adatok-kezelese/elkuldve","/uredivanje-osobnih-podataka/poslano","/urejanje-osebnih-podatkov/poslano"],
    name: "personalDataFormsSent"
  }, {
    path: "/sprava-osobnich-udaju/overeni/:hash",
    component: _1256dd74,
    alias: ["/sprava-osobnych-udajov/overenie/:hash","/zarzadzanie-danymi-osobowymi/weryfikacja/:hash","/szemelyes-adatok-kezelese/visszaigazolas/:hash","/uredivanje-osobnih-podataka/potvrda/:hash","/urejanje-osebnih-podatkov/potrditev/:hash","/personal-data-forms/verify/:hash"],
    name: "personalDataFormsVerify"
  }],

  parseQuery: function(query) {
      return require('qs').parse(query);
    },
  stringifyQuery: function(query) {
      const result = require('qs').stringify(query, { arrayFormat: 'brackets' });
      return result ? '?' + result : '';
    },
  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
